
// constants for default locale
export const DEFAULT_LOCALE = "en";

const LOCALE_CURRENCYCODE_SYMBOL_MAPPING: Record<string, { code: string; symbol: string }> = {
	af: { code: "ZAR", symbol: "R" },
	bg: { code: "BGN", symbol: "лв" },
	bn: { code: "BDT", symbol: "৳" },
	cs: { code: "CZK", symbol: "Kč" },
	da: { code: "DKK", symbol: "kr" },
	de: { code: "EUR", symbol: "€" },
	el: { code: "EUR", symbol: "€" },
	en: { code: "USD", symbol: "$" },
	en_GB: { code: "GBP", symbol: "£" },
	es: { code: "EUR", symbol: "€" },
	es_419: { code: "MXN", symbol: "$" },
	et: { code: "EUR", symbol: "€" },
	fi: { code: "EUR", symbol: "€" },
	fr: { code: "EUR", symbol: "€" },
	hi: { code: "INR", symbol: "₹" },
	hr: { code: "HRK", symbol: "kn" },
	hu: { code: "HUF", symbol: "Ft" },
	it: { code: "EUR", symbol: "€" },
	ja: { code: "JPY", symbol: "¥" },
	ko: { code: "KRW", symbol: "₩" },
	lt: { code: "EUR", symbol: "€" },
	lv: { code: "EUR", symbol: "€" },
	mn: { code: "MNT", symbol: "₮" },
	ms: { code: "MYR", symbol: "RM" },
	nb: { code: "NOK", symbol: "kr" },
	nl: { code: "EUR", symbol: "€" },
	pl: { code: "PLN", symbol: "zł" },
	pt: { code: "EUR", symbol: "€" },
	pt_BR: { code: "BRL", symbol: "R$" },
	ro: { code: "RON", symbol: "lei" },
	ru: { code: "RUB", symbol: "₽" },
	sk: { code: "EUR", symbol: "€" },
	sl: { code: "EUR", symbol: "€" },
	sv: { code: "SEK", symbol: "kr" },
	th: { code: "THB", symbol: "฿" },
	tr: { code: "TRY", symbol: "₺" },
	vi: { code: "VND", symbol: "₫" },
	zh: { code: "CNY", symbol: "¥" },
	zh_TW: { code: "TWD", symbol: "NT$" },
};

/**
 * return the Currency Code for the locale
 * if there is no locale mapping, it returns the currency code for default locale 'en'
 */
export function getCurrencyCodeForLocale(locale: string): string {
	return LOCALE_CURRENCYCODE_SYMBOL_MAPPING[locale].code || LOCALE_CURRENCYCODE_SYMBOL_MAPPING[DEFAULT_LOCALE].code;
}